<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="70%">
      <v-card>
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-toolbar dark color="deep-orange darken-3">
          <v-icon medium>{{ title.icon }}</v-icon>
          <v-toolbar-title>{{ title.text }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="close" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <!-- <v-flex xs12 md12>
                {{ item }}
              </v-flex> -->
              <v-flex xs12 md6>
                <v-text-field label="ชื่อกลุ่ม" v-model="item.name" :rules="[rules.required]" required :readonly="!allowedRoles"></v-text-field>
              </v-flex>
              
              <v-flex xs12 md6>
                <v-text-field label="จำนวนนักศึกษา" v-model="item.amount" mask="###" :rules="[rules.required]" required> :readonly="!allowedRoles"</v-text-field>
              </v-flex>
              <v-flex xs12 md12>
                <v-autocomplete
                  :items="roomItems"
                  v-model="item.room"
                  label="ห้องเรียน"
                  item-value="id"
                  item-text="label"
                  return-object
                  clearable
                  :rules="[v => !!v || 'Item is required']" 
                  required
                  :readonly="!allowedRoles"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 md12>
                <v-autocomplete
                  :items="personItems"
                  v-model="item.instructors"
                  label="อาจารย์ที่ปรึกษากลุ่ม"
                  item-value="id"
                  item-text="fullname"
                  return-object
                  multiple
                  chips
                  :rules="[v => !!v || 'Item is required']" 
                  required
                  :readonly="!allowedRoles"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="grey white--text" :loading="loading" :disabled="loading" @click.native="close">ปิด</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" :loading="loading" :disabled="loading" @click.native="onSubmit" v-if="allowedRoles">บันทึก</v-btn>
        </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import swal from 'sweetalert2'

export default {
  props: ['dialog', 'item', 'title', 'allowedRoles'],
  data () {
    return {
      loading: false,
      valid: false,
      rules: {
        required: (value) => !!value || 'ไม่สามารถเป็นค่าว่าง'
      }
    }
  },
  computed: {
    ...mapGetters({
      personItems: 'person/personItems',
      roomItems: 'roomItems'
    })
  },
  mounted () {

  },
  methods: {
    clear () {
      
    },
    close: function() {
      this.$emit('dialog', false)
    },
    onSubmit () {
      if (this.$refs.form.validate()) {
        this.loading = true
        let dispatch = this.item.id && this.item.id > 0 ? 'subSection/update' : 'subSection/create'
        this.$store.dispatch(dispatch, this.item)
          .then((response) => {
            // console.log('onSave:', response )
            this.loading = false
            swal({
              title: 'Success!',
              type: 'success'
            }).then(response => {
              this.close()
            })
          }).catch((error) => {
            this.loading = false
            swal('Error!', error.message, 'error')
          })
      }
    }
  },
  watch: {

  }
}

</script>


// WEBPACK FOOTER //
// src/components/management/course/section/shows/subSection/formDialog.vue